import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var Badge_Default_instance;
var Badge_Alternate_instance;
var Badge_entriesInitialized;
function Badge_initEntries() {
  if (Badge_entriesInitialized)
    return Unit_instance;
  Badge_entriesInitialized = true;
  Badge_Default_instance = new (Badge())('Default', 0, 1);
  Badge_Alternate_instance = new (Badge())('Alternate', 1, 2);
}
var BadgeClass;
function Badge() {
  if (BadgeClass === VOID) {
    class $ extends Enum() {
      constructor(name, ordinal, value) {
        super(name, ordinal);
        this.w2d_1 = value;
      }
    }
    initMetadataForClass($, 'Badge');
    BadgeClass = $;
  }
  return BadgeClass;
}
function Badge_Default_getInstance() {
  Badge_initEntries();
  return Badge_Default_instance;
}
function Badge_Alternate_getInstance() {
  Badge_initEntries();
  return Badge_Alternate_instance;
}
//region block: exports
export {
  Badge_Alternate_getInstance as Badge_Alternate_getInstance1a3cou6m4qliu,
  Badge_Default_getInstance as Badge_Default_getInstance1t7libtu7t8ty,
};
//endregion

//# sourceMappingURL=Badge.mjs.map
